/**
 * HomeSLDemoInvoicePageContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeSLDemoInvoicePageContent
 */

import { useHomeSLDemoInvoicePageContentLogic } from '@/hooks/traits/useHomeSLDemoInvoicePageContentLogic';
import type { HomeSLDemoInvoicePageContentConfig } from '@/hooks/traits/useHomeSLDemoInvoicePageContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeSLDemoInvoicePageItem } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { Split } from '@almadar/ui/components';
import { HomeSLDemoInvoicePageDetailView } from '@/components/traits/HomeSLDemoInvoicePageDetailView';
import { Typography } from '@almadar/ui/components';
import { HomeSLDemoInvoicePageStatsView } from '@/components/traits/HomeSLDemoInvoicePageStatsView';
import { HomeSLDemoInvoicePageListView } from '@/components/traits/HomeSLDemoInvoicePageListView';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeSLDemoInvoicePageContentViewProps {
  config?: Partial<HomeSLDemoInvoicePageContentConfig>;
}

export function HomeSLDemoInvoicePageContentView({ config: propsConfig }: HomeSLDemoInvoicePageContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeSLDemoInvoicePageContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeSLDemoInvoicePageItem'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeSL" trait="HomeSLDemoInvoicePageContent">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" className="p-4" gap="sm"><Typography content={renderPatternValue(__t("std-almadar-demo-invoices-page:page.title"))} variant="h3" /><Split ratio="2:3" gap="md"><Stack gap="sm" direction="vertical"><HomeSLDemoInvoicePageStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeSLDemoInvoicePageListView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack><HomeSLDemoInvoicePageDetailView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Split></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeSLDemoInvoicePageContentView;
